export default function Whiteboard() {
  return null;
}
